import { createContext } from 'react';
import type { BraceletGiftSettings } from '@/services/braceletGiftService';

export const BraceletGiftContext = createContext<BraceletGiftSettings | null>(null);
